import { useDispatch, useSelector } from "react-redux";
import { Modal, PatientBasicInfo, PatientMoreInfo, Tab } from "../components";
import style from "./adminPatients.module.scss";
import { patientUpdateAsync } from "../app/patientSlice";
import { MobileAppRegisterForm } from "../components/core/MobileAppRegisterForm/mobileAppRegisterForm";
import { useState } from "react";

export const AdminPatients = ({ adminPatientsModalOpen, setAdminPatientsModalOpen }) => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.patient.detailViewData);
  const updatePatientData = (data) => dispatch(patientUpdateAsync(data, "ADMIN_POPUP"));

  /* Register mobile app modal */
  const [showModal, setShowModal] = useState(false);
  const [checkTempPass, setCheckTempPass] = useState(false);

  const modalOpen = () => {
    setShowModal(true);
    setCheckTempPass(true);
  };
  const modalClose = () => {
    setShowModal(false);
    setCheckTempPass(false);
  };
      
  const tabList = [
    {
      name: "Basic Info",
      content: <PatientBasicInfo patientData={patientData} updatePatientData={updatePatientData} />,
      className: `${style.tab_bgremover}`,
    },
    {
      name: "More Info",
      content: <PatientMoreInfo patientData={patientData} updatePatientData={updatePatientData} />,
    },
  ];

  return (
    <div>
      {adminPatientsModalOpen && (
        <Modal
          modalOpen={adminPatientsModalOpen}
          modalClose={() => setAdminPatientsModalOpen(false)}
          modal_title={"w-100"}
          heading={<div className="d-flex justify-content-between">
            <div className={style.modal_heading}>{"Patient Management"}</div>
            <div className={`${style.patient_mobile_card} ml-auto pt-1`} onClick={() => modalOpen()}>
                            <svg xmlns="
                                http://www.w3.org/2000/svg"
                                width="12" height="24" viewBox="0 0 11.393 18.228">
                                <path id="Subtraction_4" data-name="Subtraction 4" d="M-4999.886-342.772h-6.835a2.279,2.279,0,0,1-2.279-2.278v-13.671a2.279,2.279,0,0,1,2.279-2.278h6.835a2.279,2.279,0,0,1,2.279,2.278v13.671A2.279,2.279,0,0,1-4999.886-342.772Zm-3.417-2.848a1.139,1.139,0,0,0-1.139,1.139,1.139,1.139,0,0,0,1.139,1.139,1.139,1.139,0,0,0,1.139-1.139A1.139,1.139,0,0,0-5003.3-345.62Zm-2.734-13.027a1.709,1.709,0,0,0-1.823,1.556v9.342a1.709,1.709,0,0,0,1.823,1.556h5.468a1.708,1.708,0,0,0,1.823-1.556v-9.342a1.708,1.708,0,0,0-1.823-1.556Z" transform="translate(5009 361)" fill="#0052cc"/>
                            </svg>
                            <p>Register patient for mobile</p>
                        </div>                       
          </div>}
          modalSize={style.custom_modal_size}
        >
          <div className="pl-2 pr-4">
            <Tab tabList={tabList} defaultIndex={0} />
          </div>
        </Modal>
      )}
      {showModal && <MobileAppRegisterForm modalOpen={showModal} modalClose={modalClose} checkTempPass={checkTempPass} />}
    </div>
  );
};
